import moment from "moment";
export const CommercialRootPath = "/portal/commercial";
export const EQUITY = "Equity";
export const LIQUID = "Liquid";
export const DEBT = "Debt";
export const OTHER = "Other";
export const UPDATE_NOMINEE = "update_nominee";
export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000
export const TRANSACTION_RESOURCE_TYPES = ["SoA Holdings", "Demat Holdings"];
export const ALL_HOLDINGS = "allHoldings";
export const ZERO_HOLDINGS = "zeroHoldings";
export const NON_ZERO_HOLDINGS = "nonZeroHoldings";
export const REGISTER_WITH_MOBILE = "MOBILE";
export const REGISTER_WITH_EMAIL = "EMAIL";
export const BANK_ACCOUNT_DETAILS = "bank_account_details";
export const MULTIPLE_BANK_REGISTRATION = "multiple_bank_registration";
export const UPDATE_IFSC = "update_ifsc";
export const IDCW_OPTION = "idcw_option";
export const UPDATE_EMAIL = "update_email";
export const UPDATE_MOBILE = "update_mobile";
export const CONSOLIDATION_FOLIOS = "consolidation_folios";
export const UNCLAIMED_PAYOUTS = "unclaimed_payouts";
export const FORM_15GH = "form_15gh";
export const FATCA = "fatca";
export const MINOR_MAJOR = "minor_major";
export const addDialCode = (mobile: string = "") => {
  if (!mobile) {
    return mobile;
  }
  if (mobile.length === 13) return mobile;
  return `+91${mobile.slice(mobile.length - 10)}`;
};

export const getDate = (value: string) => {
  if (!value) return value;
  return new Date(value);
};

export const getDateString = (value: string | Date) => {
  const d = new Date(value);
  if (!isNaN(d.getTime())) {
    d.setFullYear(Math.abs(d.getFullYear()));
    return moment(d).format("DD-MMM-YYYY");
  } else {
    if (!value) return "";
    const today = moment(value);
    return today.format("DD-MMM-YYYY");
  }
  // return '';
};
export const validUploadFileSize = 2e6;

export const validUploadFileFormats = [
  "application/pdf",
  // "image/jpeg",
  // "image/png",
  // "image/jpg",
];
export const OTP_ACTIONS = {
  register: "REGISTER",
  switch: "SWITCH",
  stp: "STP_REGISTRATION",
  PROSPECT_FOLIO_EMAIL: "PROSPECT_FOLIO_EMAIL",
  PROSPECT_FOLIO_MOBILE: "PROSPECT_FOLIO_MOBILE",
  swp: "SWP_REGISTRATION",
  sipPause: "SIP_PAUSE_CANCEL",
  otmCancel: "OTM_CANCEL",
  redeem: "REDEMPTION",
  forgot_password: "FORGOT_PWD",
  SECURITY_ANSWER: "SECURITY_ANSWER",
  additionalPurchase: "ADDITIONAL_PURCHASE",
  changeEmail: "EMAIL_CHANGE",
  changeUploadEmail: "UPLOAD_EMAIL_CHANGE",
  changeMobile: "MOBILE_CHANGE",
  newPurchase: "FRESH_PURCHASE",
  login: "LOGIN",
  otp_login: "OTP_LOGIN",
  changeTaxStatus: "TAX_STATUS",
  changeBank: "BANK_ACCOUNT_TYPE_CHANGE",
  consolidationFolios: "FOLIO_CONSOLIDATION",
  correctionFolios: "DATA_ENTRY_ERROR",
  updateNominee: "NOMINEE_CHANGE",
  changeDividend: "DIV_OPTION_CHANGE",
  PRELOGIN_UPDATE_PAN: "PRELOGIN_UPDATE_PAN",
  minorStatusChange: "MINOR_TO_MAJOR",
  changeifsc: "BANK_ACCOUNT_TYPE_CHANGE",
  updateMultipleBanks: "MULTIPLE_BANK_MANDATE",
  changeBankDetails: "BANK_ACCOUNT_DETAIL_CHANGE",
  FATCA_DECLARATION: "FATCA_CHANGE",
  FORM_15: "UPDATE_FORM15_G_H",
  CHANGE_PWD: "CHANGE_PWD",
  NEW_MOBILE_ONINE_OTP: "NEW_MOBILE_CHANGE",
  NEW_MOBILE_OFFLINE_OTP: "UPLOAD_MOBILE_CHANGE",
  UNREGISTERED_MOBILE_CHANGE: "UNREGISTERED_MOBILE_CHANGE",
  NEW_EMAIL_ONINE_OTP: "NEW_EMAIL_CHANGE",
  NEW_EMAIL_OFFLINE_OTP: "UPLOAD_EMAIL_CHANGE",
  UNREGISTERED_EMAIL_CHANGE: "UNREGISTERED_EMAIL_CHANGE",
  CHANGE_DISPLAY_NAME: "CHANGE_DISPLAY_NAME",
  TRANSMISSION_OF_UNITS: "TRANSMISSION_OF_UNITS",
  VERIFY_OTP_RESET_DEVICE: "VERIFY_OTP_RESET_DEVICE",
  RESET_DEVICE: "RESET_DEVICE",
  FRESH_PURCHASE_MOBILE: "FRESH_PURCHASE_MOBILE",
  FRESH_PURCHASE_EMAIL: "FRESH_PURCHASE_EMAIL",
};

export const panRegex = /^[A-Z]{3}[P][A-Z][0-9]{4}[A-Z]{1}$/;

export const _minDateForCalender = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 100);
  return date;
};
export const ifscRegex = /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/;
export const isAlphaNumeric = (value: string) => {
  if (/^[A-Za-z0-9 ]+$/.test(value) || !value) {
    return true;
  }
  return false;
};
export const isAlphaNumericAddress = (value: string) => {
  if (/^[A-Za-z0-9,/\\\- ]+$/.test(value) || !value) {
    return true;
  }
  return false;
};

export const minDateForCalender = () => {
  const currentYear = new Date().getFullYear();
  const day = new Date().getDay();
  const month = new Date().getMonth();
  return moment(new Date(`${currentYear - 100}-${month + 1}-${day}`)).format(
    "YYYY-MM-DD"
  );
};

export const DATA_ERROR = "data_error";

export const checkForOnlyAlphabets = (value: string) => {
  if (/^[A-Za-z ]+$/.test(value) || !value) {
    return true;
  }
  return false;
};
export const MAX_LENGTH_FOR_PAN = 10;
export const MAX_LENGTH_FOR_NOMINEE_NAME = 60;
export const MAX_LENGTH_FOR_GUARDIAN_NAME = 120;
export const MAX_LENGTH_FOR_ADDRESS = 80;
export const accountNumberRegex = /^[0-9]{9,18}$/;
export const MaxAccountNumberLength = 19;

export const accountNumberValidation = (value: string) => {
  if (
    (/^\d+$/.test(value) || !value) &&
    value.length < MaxAccountNumberLength
  ) {
    return true;
  }
  return false;
};

export const ACCOUNT_TYPE_MASTER_DATA = ["NRE", "NRO", "SAVINGS"];
export const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const MODE_OF_HOLDING_MASTER_DATA = ["Anyone/Survivor", "Single"];
export const TAX_RESIDENCY_MASTER_DATA = ["RI", "Individual", "Minor"];

export const validateIfsc = (ifsc: string) => {
  if (!ifsc) return true;
  if (/^[A-Za-z0-9]+$/.test(ifsc) && ifsc.length < 12) {
    return true;
  }
  return false;
};
export const isFloatingNumber = (value: any) => {
  const floatReg = new RegExp("^[+]?([0-9]{0,})*[.]?([0-9]{0,3})?$", "g");
  if (floatReg.test(value) || !value) {
    return true;
  }
  return false;
};
export const getBankAddress = (
  address1: string | null,
  address2: string | null,
  address3: string | null
) => {
  if (address1) {
    return address1;
  } else if (address2) {
    return address2;
  } else if (address3) {
    return address3;
  }
};
